
<form class="reg-form" name="onlineForm" [formGroup]="onlineForm" #formDir="ngForm" (ngSubmit)="onSubmit(formDir, [successModal,noRecordModal,existMemberModal,iSuriModal,failedModal])" novalidate>
	<div>
		<div class="form-group row">

			<div class="alert alert-danger hide" id="topAlert" role="alert">
				<span class="errorText" id="errorMsg" [innerHTML]="'error.' + showErrorMsg() | translate: { value1: showErrorCode() }"></span>
			</div>
			
			<label class="col-12 col-sm-5 col-md-4 col-form-label" for="idNo" >{{ 'fieldLabel.myKad' | translate }} <span class="redText"> *</span></label>
			
			<div class="col-12 col-sm-7 col-md-7">
				<div class="row" formGroupName="myKadNo" ng-model="myKadNo">
					<div class="col-4 col-sm-4 col-md-4 col-lg-2">
						<input class="form-control form-control-sm" type="text"  formControlName="first" id="first" #first aria-describedby="first" maxlength="6" [appAutoTab]="middle" autocomplete="off" placeholder="{{ 'placeholder.myKad.first' | translate }}" required > 
					</div>
					&mdash;
					<div class="col-3 col-sm-3 col-md-2 col-lg-2">
						<input class="form-control form-control-sm" type="text"  formControlName="middle" id="middle" #middle aria-describedby="middle" maxlength="2" [appAutoTab]="end" autocomplete="off" placeholder="{{ 'placeholder.myKad.middle' | translate }}" required >
					</div>
					&mdash;
					<div class="col-3 col-sm-3 col-md-4 col-lg-2">
						<input class="form-control form-control-sm" type="text"  formControlName="end" id="end" #end aria-describedby="end" maxlength="4" autocomplete="off" placeholder="{{ 'placeholder.myKad.end' | translate }}" required > 
					</div>	
					
					<div *ngIf="onlineForm.controls.myKadNo.touched">
						<span class="errorText" *ngIf="onlineForm.errors?.requireMyKadNo">{{ 'error.myKadNo' | translate}}</span>
						<span class="errorText" *ngIf="onlineForm.errors?.verifyMyKadNo">{{ 'error.ICformat' | translate}}</span>
					</div>	
				</div>
			</div>
		</div>

		<div class="form-group row">	
			<label class="col-12 col-sm-5 col-md-4 col-form-label" for="businessTypeCode" >{{ 'fieldLabel.occupation' | translate }} <span class="redText"> *</span></label>
			<div class="col-12 col-sm-7 col-md-4 col-lg-4">
	
				<select ng-model="businessTypeCode" class="form-control form-control-sm" formControlName="businessTypeCode" (change)="changeField($event)"  required >
					<option value="" selected disabled>{{ 'placeholder.occupation' | translate }}</option>
					<option value={{field}} *ngFor="let field of occupationList" [innerHTML]=" 'occupationList.'+field | translate "></option>
				</select>
				<div *ngIf="onlineForm.controls.businessTypeCode.touched">
					<span class="errorText" *ngIf="onlineForm.controls.businessTypeCode.errors?.required">{{ 'error.occupation' | translate }}</span>				
				</div>
				
				<input type="text" ng-model="remarks" class="form-control form-control-sm mt-4 hide" formControlName="remarks" id="remarks" aria-describedby="remarks" autocomplete="off" maxlength="40" placeholder="{{ 'placeholder.remarks' | translate }}" >
				<span class="errorText" *ngIf="onlineForm.errors?.optionalField">{{ 'error.remarks' | translate }}</span>
			</div>
				
		</div>

		<div class="form-group row" >	
			<div class="col-12 col-sm-12 box-tnc">
				<div class="row">
					<input type="checkbox" ng-model="perakuanCheckbox" class="col-1" formControlName="perakuanCheckbox" id="perakuanCheckbox" aria-describedby="perakuanCheckbox"  required> 
					<div class="col-11"> 
						<ol class="text-justify">    
							<li class="text-justify" *ngFor="let item of getTranslatedItems('perakuanPemohon') | keyvalue; let parentIndex = index">
								{{ item.value.title }}

								<ol class="lower-roman" *ngIf="item.value.terms">
									<li class="text-justify" *ngFor="let nestedItem of item.value.terms | keyvalue; let termIndex = index">
										{{ nestedItem.value }}
									</li>
								</ol>

								
							</li>
						</ol>
					</div>					
				</div>
			</div>	
			<label class="col-sm-4 col-md-3 col-form-label"></label>
			<div class="col-12 col-sm-12">
				<span class="errorText" *ngIf="onlineForm.controls['perakuanCheckbox'].errors?.required">{{ 'error.Perakuan' | translate }}</span>
			</div>	
		</div>

		<div class="form-group">
			<div class="row">			
				<div class="col-12 col-sm-12">
					<re-captcha (resolved)="resolved($event)" 
						formControlName="recaptchaReactive" 
						siteKey="6LcJcSEdAAAAAGf8uKDBx8K1GW5exWcJFCz7IGEi">  <!--  6LdB0lEcAAAAAITJr7XAM1SwxW_KaIEAhrfROpaq   --> 
					</re-captcha>
					<span class="errorText" *ngIf="onlineForm.controls['recaptchaReactive'].errors?.required">{{ 'error.Captcha' | translate }}</span>
				</div>	
			</div>	
		</div>		
		
		<div class="btn-container">
			<button type="button"  class="btn btn-kwsp-clear" id="btn-reset" (click)="refreshForm();" >{{ 'buttons.Clear' | translate }}</button>
			<button type="submit" class="btn btn-kwsp-submit"  id="btn-submit" [disabled]="onlineForm.invalid">{{ 'buttons.Submit' | translate }}</button>
		</div>			
	</div>

	<!-- POPUP MODAL -->
	<ng-template #successModal id="successModal" let-modal>
		<div class="modal-body">
			<img [src]=" 'popup.successful.icon' | translate " width='70px'>
			<p [innerHTML]=" 'popup.successful.title' | translate "></p>
			<p>
				<span [innerHTML]=" 'popup.successful.info-1' | translate "></span>
				<span>
					<a [href]=" 'popup.successful.info-2' | translate " appExternalUrl>{{ 'popup.successful.info-3' | translate }}</a>
				</span>
			</p>
		  <img src="{{ 'paymentImg' | translate }}" width="100%">
		  <br>
		  <div id="iAkaunPromo" class="alert alert-warning" [innerHTML]=" 'popup.iAkaunInfo' | translate "></div>
		</div>
		<div class="modal-footer btn-container">
		  <button type="button" class="btn btn-kwsp-submit btn_close" (click)="modal.close('Save click');resetForm();" >{{ 'buttons.Close' | translate }}</button>
		</div>
	</ng-template>

	<ng-template #noRecordModal id="noRecordModal" let-modal>
		<div class="modal-body">
			<img [src]=" 'popup.scenario1.icon' | translate " width='70px'>
		  	<p [innerHTML]=" 'popup.scenario1.title' | translate "></p>
			<p>
				<span [innerHTML]=" 'popup.scenario1.info-1' | translate "></span>
				<span>
					<a [href]=" 'popup.scenario1.info-2' | translate " appExternalUrl>{{ 'popup.scenario1.info-3' | translate }}</a>
				</span>
			</p>
		</div>
		<div class="modal-footer btn-container">
		  <button type="button" class="btn btn-kwsp-submit btn_close" (click)="modal.close('Save click');resetForm();" >{{ 'buttons.Close' | translate }}</button>
		</div>
	</ng-template>

	<ng-template #existMemberModal id="existMemberModal" let-modal>
		<div class="modal-body">
			<p [innerHTML]=" 'popup.scenario2.title' | translate "></p>
			<p>
				<span [innerHTML]=" 'popup.scenario2.info-1' | translate "></span>
				<span>
					<a [href]=" 'popup.scenario2.info-2' | translate " appExternalUrl>{{ 'popup.scenario2.info-3' | translate }}</a>
				</span>
			</p>
			<img src="{{ 'paymentImg' | translate }}" width="100%">
			<br>		  
		</div>
		<div class="modal-footer btn-container">
		  <button type="button" class="btn btn-kwsp-submit btn_close" (click)="modal.close('Save click');resetForm();" >{{ 'buttons.Close' | translate }}</button>
		</div>
	</ng-template>
	
	<ng-template #iSuriModal id="iSuriModal" let-modal>
		<div class="modal-body">	
			<img id='icon_success' [src]=" 'popup.scenario3.icon' | translate " width='70px'>
			<p [innerHTML]=" 'popup.scenario3.title' | translate "></p>
			<p>
				<span [innerHTML]=" 'popup.scenario3.info-1' | translate "></span>
				<span>
					<a [href]=" 'popup.scenario3.info-2' | translate " appExternalUrl>{{ 'popup.scenario3.info-3' | translate }}</a>
				</span>
			</p>			
		</div>
		<div class="modal-footer btn-container">
		  <button type="button" class="btn btn-kwsp-submit btn_close" (click)="modal.close('Save click');resetForm();" >{{ 'buttons.Close' | translate }}</button>
		</div>
	</ng-template>
	
	<ng-template #failedModal id="failedModal" let-modal>
		<div class="modal-body">
			<img [src]=" 'popup.scenario4.icon' | translate " width='70px'>
			<p [innerHTML]=" 'popup.scenario4.title' | translate "></p>
			<p>
				<span [innerHTML]=" 'popup.scenario4.info-1' | translate "></span>
				<span>
					<a [href]=" 'popup.scenario4.info-2' | translate " appExternalUrl>{{ 'popup.scenario4.info-3' | translate }}</a>
				</span>
			</p>	
		</div>
		<div class="modal-footer btn-container">
		  <button type="button" class="btn btn-kwsp-submit btn_close" (click)="modal.close('Save click');resetForm();" >{{ 'buttons.Close' | translate }}</button>
		</div>
	</ng-template>
	<!-- End Popup -->

	<!-- Loading -->
	<div class="loading-container">
		<div class="loading-content text-center">
			<img src="./assets/images/logo.svg" class="loading_logo" />
			<p><small>{{ 'Loading' | translate }}</small></p>
		</div>
	</div>
	<!-- End Loading -->
</form>
